import { render, staticRenderFns } from "./LogAgentTransactions.vue?vue&type=template&id=2f70d99b&"
import script from "./LogAgentTransactions.vue?vue&type=script&lang=js&"
export * from "./LogAgentTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports